/// ///////////////////////////////////////////////////////////////////////////
//  Copyright (C) 2013 by sanpolo CO.LTD                                    //
//                                                                          //
//  This file is part of WIDE                                               //
//                                                                          //
//  You should have received a copy of the WIDE License along with this     //
//  program.  If not, see <http://www.wware.org/wide/license.html>.         //
//                                                                          //
//  WIDE website: http://www.wware.org/                                     //
/// ///////////////////////////////////////////////////////////////////////////
// Created At : 2019-01-30T11:59:07.543Z by lizhutang (lizhutang@spolo.org)

'use strict'

/**
用于初始化CKEDITOR在线编辑。
@module ckeditor
*/

const stopPropagation = e => e.stopPropagation()
let c, CKEDITOR

/**
    * Function to determine Viewport Size
    */
function getWindowDims (editor) {
  var doc = editor.Canvas.getDocument(); var w = editor.Canvas.getWindow()
  var docEl = (doc.compatMode && doc.compatMode === 'CSS1Compat')
    ? doc.documentElement : doc.body

  var width = docEl.clientWidth
  var height = docEl.clientHeight

  // mobile zoomed in?
  if (w.innerWidth && width > w.innerWidth) {
    width = w.innerWidth
    height = w.innerHeight
  }

  // IMPORTANT!!!!
  // Glutter Handle information
  var glutterHandleObj = $(document).find('.gjs-cv-canvas').find('.iframe-handle-container')
  if (glutterHandleObj.length > 0) {
    var leftGlutterHandleBar = glutterHandleObj.find('.left-handle')
    var rightGlutterHandleBar = glutterHandleObj.find('.right-handle')

    var leftOffset = $('.gjs-frame')[0].offsetLeft
    var rightOffset = $('.gjs-frame')[0].offsetLeft + $('.gjs-frame').width()

    leftGlutterHandleBar.css('cssText', 'left: ' + leftOffset + 'px !important')
    rightGlutterHandleBar.css('cssText', 'left: ' + rightOffset + 'px !important')
    glutterHandleObj.removeClass('hidden')
  }

  return { width: width, height: height }
}

const customRTE = {
  /**
   * Enabling the custom RTE
   * @param  {Object} editor 当前的grapesjs编辑器实例。
   * @param  {HTMLElement} el This is the HTML node which was selected to be edited
   * @param  {Object} rte It's the instance you'd return from the first call of enable().
   *                      At the first call it'd be undefined. This is useful when you need
   *                      to check if the RTE is already enabled on the component
   * @return {Object} The return should be the RTE initialized instance
   */
  enable: function (editor, el, rte) {
    // If already exists I'll just focus on it
    if (rte && rte.status !== 'destroyed') {
      this.focus(editor, el, rte)
      return rte
    }

    el.contentEditable = true

    // Seems like 'sharedspace' plugin doesn't work exactly as expected
    // so will help hiding other toolbars already created
    let rteToolbar = editor.RichTextEditor.getToolbarEl();
    [].forEach.call(rteToolbar.children, (child) => {
      child.style.display = 'none'
    })

    // Check for the mandatory options
    var opt = c.options
    var plgName = 'sharedspace'

    if (opt.extraPlugins) {
      if (typeof opt.extraPlugins === 'string') { opt.extraPlugins += ',' + plgName } else { opt.extraPlugins.push(plgName) }
    } else {
      opt.extraPlugins = plgName
    }

    if (!c.options.sharedSpaces) {
      c.options.sharedSpaces = { top: rteToolbar }
    }

    // Init CkEditors
    rte = window.CKEDITOR.inline(el, c.options)

    // Make click event propogate
    rte.on('contentDom', () => {
      var editable = rte.editable()
      editable.attachListener(editable, 'click', () => {
        el.click()
      })
    })

    // The toolbar is not immediatly loaded so will be wrong positioned.
    // With this trick we trigger an event which updates the toolbar position
    rte.on('instanceReady', e => {
      var toolbar = rteToolbar.querySelector('#cke_' + rte.name)
      if (toolbar) {
        toolbar.style.display = 'block'
      }
      editor.trigger('canvasScroll')
    })

    // Prevent blur when some of CKEditor's element is clicked
    rte.on('dialogShow', e => {
      const editorEls = window.grapesjs.$('.cke_dialog_background_cover, .cke_dialog');
      ['off', 'on'].forEach(m => editorEls[m]('mousedown', stopPropagation))
    })

    this.focus(editor, el, rte)

    return rte
  },
  /**
   * The signature of the function is the same of the enable
   */
  disable: function (editor, el, rte) {
    el.contentEditable = false
    if (rte && rte.focusManager) {
      rte.focusManager.blur(true)
    }
  },
  focus: function (editor, el, rte) {
    // Do nothing if already focused
    if (rte && rte.focusManager.hasFocus) {
      return
    }
    el.contentEditable = true
    rte && rte.focus()
  }

}

export default {
  setCustomRte: function (editor) {
    if (!CKEDITOR) {
      let defaults = {
        // CKEditor options
        options: {
          language: 'zh-cn'
        },

        // On which side of the element to position the toolbar
        // Available options: 'left|center|right'
        position: 'center'
      }
      // Load defaults
      c = c || {}
      for (let name in defaults) {
        if (!(name in c)) {
          c[name] = defaults[name]
        }
      }

      if (!window.CKEDITOR) {
        throw new Error('CKEDITOR instance not found')
      }
      CKEDITOR = window.CKEDITOR

      // CKEDITOR.disableAutoInline = true
      // console.log(CKEDITOR.dtd);
      CKEDITOR.dtd.$removeEmpty.span = false
      CKEDITOR.config.language = 'zh-cn'
      CKEDITOR.config.chart_maxItems = 16
      // plugin do not change the content of editor by default
      CKEDITOR.config.templates_replaceContent = false
      CKEDITOR.stylesSet.add('default', [{
        name: '清空样式',
        element: ['p', 'span', 'div'],
        attributes: {
          'class': ''
        }
      }, {
        name: '大文本',
        element: 'big'
      }, {
        name: 'IMG',
        element: 'img',
        attributes: {
          'class': 'img-responsive'
        }
      }, {
        name: '小文本',
        element: 'small'
      }, {
        name: '右方引用',
        element: ['blockquote'],
        attributes: {
          'class': '.blockquote-reverse'
        }
      }, {
        name: '左浮动',
        element: ['p', 'span', 'div', 'img'],
        attributes: {
          'class': 'pull-left'
        }
      }, {
        name: '右浮动',
        element: ['p', 'span', 'div', 'img'],
        attributes: {
          'class': 'pull-right'
        }
      }, {
        name: '引文',
        element: ['p', 'span'],
        attributes: {
          'class': 'lead'
        }
      }, {
        name: '类控件样式',
        element: ['p', 'span'],
        attributes: {
          'class': 'form-control-static'
        }
      }, {
        name: '验证指示标签',
        element: 'lable',
        attributes: {
          'class': 'control-label'
        }
      }, {
        name: '帮助文本样式',
        element: ['span', 'p'],
        attributes: {
          'class': 'help-block'
        }
      }, {
        name: '禁用文本样式',
        element: ['p', 'span'],
        attributes: {
          'class': 'text-muted'
        }
      }, {
        name: '原色文本样式',
        element: ['p', 'span'],
        attributes: {
          'class': 'text-primary'
        }
      }, {
        name: '成功文本样式',
        element: ['p', 'span'],
        attributes: {
          'class': 'text-success'
        }
      }, {
        name: '信息文本样式',
        element: ['p', 'span'],
        attributes: {
          'class': 'text-info'
        }
      }, {
        name: '警告文本样式',
        element: ['p', 'span'],
        attributes: {
          'class': 'text-warning'
        }
      }, {
        name: '错误文本样式',
        element: ['p', 'span'],
        attributes: {
          'class': 'text-danger'
        }
      }, {
        name: '文本不换行',
        element: ['p', 'span'],
        attributes: {
          'class': 'text-nowrap'
        }
      }, {
        name: '显示dotjs语句',
        element: ['p', 'span', 'div'],
        attributes: {
          'class': 'escape'
        }
      }, {
        name: '高亮',
        element: 'mark'
      }, {
        name: '按键组合',
        element: 'kbd'
      }, {
        name: '缩略语',
        element: 'abbr'
      }, {
        name: '地址',
        element: 'address'
      }, {
        name: '列表项',
        element: 'li'
      }, {
        name: '无顺序列表',
        element: 'ul'
      }, {
        name: '有顺序列表',
        element: 'ol'
      }, {
        name: '描述列表',
        element: 'dl'
      }, {
        name: '示例输出风格',
        element: 'samp'
      }, {
        name: '变量风格',
        element: 'var'
      }, {
        name: 'div',
        element: 'div'
      }, {
        name: 'p',
        element: 'p'
      }, {
        name: '缩略语小字体样式',
        element: 'abbr',
        attributes: {
          'class': 'initialism'
        }
      }, {
        name: '下拉列表样式',
        element: ['ul', 'ol', 'dl'],
        attributes: {
          'class': 'dropdown-menu'
        }
      }, {
        name: '列表无样式',
        element: ['ul', 'ol'],
        attributes: {
          'class': 'list-unstyled'
        }
      }, {
        name: '水平列表',
        element: ['ul', 'ol'],
        attributes: {
          'class': 'list-inline'
        }
      }, {
        name: '水平对齐描述表',
        element: 'dl',
        attributes: {
          'class': 'dl-horizontal'
        }
      }, {
        name: '条纹表格',
        element: 'table',
        attributes: {
          'class': 'table table-striped table-bordered table-condensed table-hover'
        }
      }, {
        name: '工具条',
        element: ['div', 'p', 'a'],
        attributes: {
          'class': 'btn-group btn-group-vertical btn-group-sm'
        }
      }
      ])
      CKEDITOR.config.font_names = "百度/arial, 'Hiragino Sans GB', 'Microsoft Yahei', 微软雅黑, 宋体, 宋体, Tahoma, Arial, Helvetica, STHeiti;淘宝/tahoma, arial, 'Hiragino Sans GB', 宋体, sans-serif;微博/Arial, 'Microsoft YaHei';Bootstrap中文站/\"Helvetica Neue\", Helvetica, Microsoft Yahei, Hiragino Sans GB, WenQuanYi Micro Hei, sans-serif;腾讯新闻1/宋体, Arial, sans-serif;腾讯新闻2/宋体, 'Arial Narrow', HELVETICA;京东1/Arial, Verdana, 宋体;微软雅黑/'microsoft yahei';亚马逊/arial, sans-serif;知乎/'Helvetica Neue', Helvetica, Arial, sans-serif;Arial/Arial, Helvetica, sans-serif;Comic Sans MS/Comic Sans MS, cursive;Courier New/Courier New, Courier, monospace;Georgia/Georgia, serif;Lucida Sans Unicode/Lucida Sans Unicode, Lucida Grande, sans-serif;Tahoma/Tahoma, Geneva, sans-serif;Times New Roman/Times New Roman, Times, serif;Trebuchet MS/Trebuchet MS, Helvetica, sans-serif;Verdana/Verdana, Geneva, sans-serif"
      // CKEDITOR.config.fontSize_defaultLabel = '尺寸';
      CKEDITOR.config.fontSize_sizes = '八号(5磅)/1.75mm;七号(5.5磅)/1.925mm;小六(6.5磅)/2.275mm;六号(7.5磅)/2.625mm;小五(9磅)/3.15mm;五号(10.5磅)/3.675mm;小四(12磅)/4.2mm;四号(14磅)/4.9mm;小三(15磅)/5.25mm;三号(16磅)/5.6mm;小二(18磅)/6.3mm;二号(22磅)/7.7mm;小一(24磅)/8.4mm;一号(26磅)/9.1mm;小初(36磅)/12.6mm;初号(42磅)/14.7mm'

      CKEDITOR.config.indentOffset = '2'
      CKEDITOR.config.indentUnit = 'em'
      // Displays document group with its two subgroups.
      // Group's name will be used to create voice label.
      // '/', // Line break - next group will be placed in new line.
      // CKEDITOR.config.toolbarGroups = [
      //   // { name: 'document', groups: [ 'mode', 'document' ] },
      //   { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
      //   { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
      //   { name: 'links' }
      // ]
      // CKEDITOR.config.removeButtons = 'Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField'
      CKEDITOR.config.toolbar = [
        ['NewPage', 'SelectAll', 'Find', 'Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord'],
        ['Undo', 'Redo'],
        ['Font', 'FontSize', 'TextColor', 'BGColor'],
        ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', 'RemoveFormat'],
        ['NumberedList', 'BulletedList', 'Outdent', 'Indent'],
        '/',
        ['Styles', 'Format'],
        ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'],
        ['Link', 'Unlink', 'Anchor'],
        ['CreateDiv', 'Blockquote', 'CreatePlaceholder', 'Image', 'Flash', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak', 'InsertPre'],
        ['ShowBlocks', 'Maximize', 'UIColor']
      ]

      c.options.removePlugins = 'magicline,WebSpellChecker,iframe'
      c.options.justifyClasses = ['text-left', 'text-center', 'text-right', 'text-justify']
      c.options.language_list = ['zh:中文', 'en:英文', 'ar:阿拉伯文:rtl', 'fr:法文', 'es:西班牙文']
      c.options.undoStackSize = 50
      // c.options.skin = 'office2013'
      c.options.contentsCss = wwjs.loadjs.resolve(['@/bootstrap/4.1.3/css/bootstrap.min.css', '@/font-awesome/4.7.0/css/font-awesome.min.css'])
      c.options.fullPage = false
    }
    editor.setCustomRte({
      enable: customRTE.enable.bind(customRTE, editor),
      disable: customRTE.disable.bind(customRTE, editor),
      focus: customRTE.focus.bind(customRTE, editor)
    })

    // Update RTE toolbar position
    editor.on('rteToolbarPosUpdate', (pos) => {
      // Update by position
      switch (c.position) {
        case 'center':
          let diff = (pos.elementWidth / 2) - (pos.targetWidth / 2)
          pos.left = pos.elementLeft + diff
          break
        case 'right':
          let width = pos.targetWidth
          pos.left = pos.elementLeft + pos.elementWidth - width
          break
      }

      if (pos.top <= pos.canvasTop) {
        pos.top = pos.elementTop + pos.elementHeight
      }

      // Check if not outside of the canvas
      if (pos.left < pos.canvasLeft) {
        pos.left = pos.canvasLeft
      }
      // console.log('pos=', JSON.stringify(pos))
      let windims = getWindowDims(editor)
      // console.log(windims)
      if (pos.top >= windims.height) {
        if (pos.canvasTop >= pos.targetHeight * 2) {
          pos.top = pos.canvasTop + 20
        } else {
          pos.top = windims.height - pos.targetHeight - 20
        }
      }
    })
  }
}
